import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { Provider, connect } from 'react-redux';

import reducer from '../../../reducers/communities/manager_recruitments';
import saga from '../../../sagas/communities/manager_recruitments';
import actionCreators from '../../../actions/communities/manager_recruitments';
import ModalAlert from '../../../components/modal/modal_alert_for_communities';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

// 使われていない
export default class ManagerRecruitments extends Component {
  render() {
    return (
      <Provider store={store}>
        <Root
          managerRecruitId={this.props.managerRecruitId}
          circleId={this.props.circleId}
          userId={this.props.userId}
          familyName={this.props.familyName}
          firstName={this.props.firstName}
          isManagerScreeningRequired={this.props.isManagerScreeningRequired}
          isCircleScreeningRequired={this.props.isCircleScreeningRequired}
        />
      </Provider>
    );
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0, // 表示内容(0: 募集詳細, 1: 入力フォーム)
      prefs: [
        <option key={'all'} value="">
          選択してください
        </option>,
      ], // 都道府県リスト
      cities: [
        <option key={'all'} value="">
          選択してください
        </option>,
      ], // 市区町村リスト
      myCircles: [
        <option key={'all'} value="">
          選択してください
        </option>,
      ], // 自分が管理人をしているサークル
    };
  }

  /**
   * コンポーネントマウント時の処理
   */
  UNSAFE_componentWillMount() {
    // アンバサダー詳細取得
    this.props.getManagerRecruitmentDetail(this.props.managerRecruitId);
    // 都道府県リスト取得
    this.props.getPrefList();
    // マイサークルリスト取得
    this.props.getMyCircleList();
  }

  /**
   * マウントされたコンポーネントが新しいpropsを受け取る前の処理
   * @param {*} nextProps 新しいprops
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.prefList != this.props.prefList) {
      // 都道府県リスト作成
      let prefs = [
        <option key={'all'} value="">
          選択してください
        </option>,
      ];
      nextProps.prefList.forEach((pref) => {
        prefs.push(<option value={pref.id.toString()}>{pref.name}</option>);
      });
      this.setState({
        prefs,
      });
    }
    if (nextProps.cityList != this.props.cityList) {
      // 市区町村リスト作成
      let cities = [
        <option key={'all'} value="">
          選択してください
        </option>,
      ];
      nextProps.cityList.forEach((city) => {
        cities.push(<option value={city.city_name}>{city.city_name}</option>);
      });
      this.setState({
        cities,
      });
    }
    if (nextProps.myCircleList != this.props.myCircleList) {
      // マイサークルリスト作成
      let myCircles = [
        <option key={'all'} value="">
          選択してください
        </option>,
      ];
      nextProps.myCircleList.forEach((myCircle) => {
        if (
          myCircle.manager_status === 1 &&
          myCircle.circle.is_draft === false
        ) {
          myCircles.push(
            <option value={myCircle.circle.id.toString()} key={myCircle.id}>
              {myCircle.circle.name}
            </option>
          );
        }
      });
      this.setState({
        myCircles,
      });
    }
  }

  render() {
    return (
      <div>
        {/* ページタイトル */}
        {/* <div className="page-header">
          <h1>アンバサダー募集</h1>
        </div> */}
        {this.state.index == 0 ? (
          <DetailArea
            onClickButton={() => {
              this.setState({ index: 1 });
            }}
            managerRecruitmentDetail={this.props.managerRecruitmentDetail}
            userId={this.props.userId}
            managerRecruitId={this.props.managerRecruitId}
            communityId={this.props.circleId}
          />
        ) : (
          <FormArea
            onClickCancelButton={() => {
              this.setState({ index: 0 });
            }}
            onSubmit={(
              companiesCirclesManagerRecruitId,
              companyId,
              communityId,
              userId,
              circleId,
              userComment,
              userPrefId,
              userAddress,
              userPostal,
              userTel,
              userFamilyname,
              userFirstname,
              facebookUrl,
              twitterUrl,
              instagramUrl
            ) =>
              this.props.createManagerRecruitsUsers(
                companiesCirclesManagerRecruitId,
                companyId,
                communityId,
                userId,
                circleId,
                userComment,
                userPrefId,
                userAddress,
                userPostal,
                userTel,
                userFamilyname,
                userFirstname,
                facebookUrl,
                twitterUrl,
                instagramUrl
              )
            }
            managerRecruitmentDetail={this.props.managerRecruitmentDetail}
            getCityList={(prefId) => this.props.getCityList(prefId)}
            prefs={this.state.prefs}
            cities={this.state.cities}
            myCircles={this.state.myCircles}
            userId={this.props.userId}
            modalIsOpen={this.props.modalIsOpen}
            createStatus={this.props.createStatus}
            createdCircleId={this.props.createdCircleId}
            familyName={this.props.familyName}
            firstName={this.props.firstName}
            isManagerScreeningRequired={this.props.isManagerScreeningRequired}
            isCircleScreeningRequired={this.props.isCircleScreeningRequired}
          />
        )}
      </div>
    );
  }
}

class DetailArea extends Component {
  /**
   * Userが未登録の場合新規作成ページへ
   */
  toUserCreatePage() {
    window.location.href = `/users/sign_up?rurl=/ambassadors/`;
  }
  render() {
    return (
      <div>
        {/* <h4 className="mt20">画像</h4>
        <div className="circle-list-img-wrap" style={{width: '100px', height: '100px'}}>
          <img src={this.props.managerRecruitmentDetail.main_image_url} />
        </div>
        {this.props.managerRecruitmentDetail.sub_image1_url && <div className="circle-list-img-wrap" style={{width: '100px', height: '100px'}}>
          <img src={this.props.managerRecruitmentDetail.sub_image1_url} />
        </div>}
        {this.props.managerRecruitmentDetail.sub_image2_url && <div className="circle-list-img-wrap" style={{width: '100px', height: '100px'}}>
          <img src={this.props.managerRecruitmentDetail.sub_image2_url} />
        </div>}
        {this.props.managerRecruitmentDetail.sub_image3_url && <div className="circle-list-img-wrap" style={{width: '100px', height: '100px'}}>
          <img src={this.props.managerRecruitmentDetail.sub_image3_url} />
        </div>}
        {this.props.managerRecruitmentDetail.sub_image4_url && <div className="circle-list-img-wrap" style={{width: '100px', height: '100px'}}>
          <img src={this.props.managerRecruitmentDetail.sub_image4_url} />
        </div>}
        {this.props.managerRecruitmentDetail.sub_image5_url && <div className="circle-list-img-wrap" style={{width: '100px', height: '100px'}}>
          <img src={this.props.managerRecruitmentDetail.sub_image5_url} />
        </div>} */}

        {/* 仮申込ボタン */}
        {/* <p>まずは仮申込してみよう！</p> */}
        <button
          className="btn btn-lg btn-info mt20 mb20"
          style={{ width: '100%', margin: '10px 0' }}
          onClick={
            this.props.userId !== 0
              ? this.props.onClickButton
              : this.toUserCreatePage.bind(this)
          }
        >
          アンバサダーに申し込む
        </button>
      </div>
    );
  }
}

const FIELDS = {
  circleId: 'circleId',
  userPostal: 'userPostal',
  userPrefId: 'userPrefId',
  userCityName: 'userCityName',
  userAddress: 'userAddress',
  userTel: 'userTel',
  userFamilyname: 'userFamilyname',
  userFirstname: 'userFirstname',
  userComment: 'userComment',
  facebookUrl: 'facebookUrl',
  twitterUrl: 'twitterUrl',
  instagramUrl: 'instagramUrl',
};

class FormArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      circleType: '1', // 0: 新規でサークルを立ち上げ予定, 1: 既存サークルで申込
      circleId: '', // 応募者サークルID(null: 新規でサークルを立ち上げ予定)
      userPostal: '', // 応募者の郵便番号
      userPrefId: '', // 応募者の都道府県ID
      userCityName: '', // 応募者の市区町村の名前
      userAddress: '', // 応募者の住所（都道府県以降）
      userTel: '', // 応募者の電話番号
      userFamilyname: this.props.userId !== 0 ? this.props.familyName : '', // 応募者の苗字
      userFirstname: this.props.userId !== 0 ? this.props.firstName : '', // 応募者の名前
      userComment: '', // 応募者からのPR文
      facebookUrl: '',
      twitterUrl: '',
      instagramUrl: '',
      errors: {},
    };
    this.onChangeField = this.onChangeField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.toNextPage = this.toNextPage.bind(this);
    this.handleFormBlur = this.handleFormBlur.bind(this);
  }

  /**
   * マウントされたコンポーネントが新しいpropsを受け取る前の処理
   * @param {*} nextProps 新しいprops
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalIsOpen) {
      // モーダルオープン
      switch (nextProps.createStatus) {
        case 'success':
          this.modalAlertSuccess.openModal();
          break;
        case 'error':
          this.modalAlertError.openModal();
          break;
      }
    }
  }

  isDisabled() {
    if (
      this.state.circleId == '' ||
      this.state.userFamilyname == '' ||
      this.state.userFirstname == '' ||
      this.state.userComment == ''
    ) {
      return true;
    }
    return false;
  }

  validate(field, value) {
    let isValid = true;
    switch (field) {
      case FIELDS.circleId:
        isValid = value != '';
        break;
      case FIELDS.userPostal:
        isValid = value != '';
        break;
      case FIELDS.userPrefId:
        isValid = value != '';
        break;
      case FIELDS.userCityName:
        isValid = value != '';
        break;
      case FIELDS.userAddress:
        isValid = value != '';
        break;
      case FIELDS.userTel:
        isValid = value != '';
        break;
      case FIELDS.userFamilyname:
        isValid = value != '';
        break;
      case FIELDS.userFirstname:
        isValid = value != '';
        break;
      case FIELDS.userComment:
        isValid = value != '';
        break;
      case FIELDS.facebookUrl:
        isValid = !(
          value == '' &&
          this.state.twitterUrl == '' &&
          this.state.instagramUrl == ''
        );
        break;
      case FIELDS.twitterUrl:
        isValid = !(
          value == '' &&
          this.state.facebookUrl == '' &&
          this.state.instagramUrl == ''
        );
        break;
      case FIELDS.instagramUrl:
        isValid = !(
          value == '' &&
          this.state.facebookUrl == '' &&
          this.state.twitterUrl == ''
        );
        break;
      default:
        break;
    }

    return isValid;
  }

  /**
   * 入力エリアの値が変更された時の処理
   * @param {*} e
   */
  onChangeField(e) {
    if (e.target.id == 'userPrefId') {
      // 都道府県の場合
      this.props.getCityList(e.target.value);
      this.setState({
        [e.target.id]: e.target.value,
        userCityName: '',
      });
    } else {
      this.setState({
        [e.target.id]: e.target.value,
      });
    }
  }

  handleFormBlur(e) {
    const field = e.target.id;
    if (
      field == FIELDS.facebookUrl ||
      field == FIELDS.twitterUrl ||
      field == FIELDS.instagramUrl
    ) {
      this.setState({
        errors: {
          ...this.state.errors,
          [FIELDS.facebookUrl]: !this.validate(field, e.target.value),
          [FIELDS.twitterUrl]: !this.validate(field, e.target.value),
          [FIELDS.instagramUrl]: !this.validate(field, e.target.value),
        },
      });
    } else {
      this.setState({
        errors: {
          ...this.state.errors,
          [field]: !this.validate(field, e.target.value),
        },
      });
    }
  }

  /**
   * 登録ボタン押下時の処理
   */
  onSubmit() {
    this.props.onSubmit(
      this.props.managerRecruitmentDetail.id,
      this.props.managerRecruitmentDetail.company_id,
      this.props.managerRecruitmentDetail.circle_id,
      this.props.userId,
      this.state.circleType == '0' ? null : Number(this.state.circleId),
      this.state.userComment,
      this.state.userPrefId == '' ? null : Number(this.state.userPrefId),
      this.state.userCityName + this.state.userAddress,
      this.state.userPostal,
      this.state.userTel,
      this.state.userFamilyname,
      this.state.userFirstname,
      this.state.facebookUrl,
      this.state.twitterUrl,
      this.state.instagramUrl
    );
  }

  /**
   * 次のページに遷移する処理
   */
  toNextPage() {
    // if(this.state.circleType == '0') {
    //   window.location.href = `/my_circle/${this.props.createdCircleId}/edit`;
    // } else {
    //   window.location.href = `/communities/${this.props.managerRecruitmentDetail.circle_id}`;
    // }
    // 一時的にトップ画面に返すように修正
    window.location.href = '/';
  }

  render() {
    return (
      <div onBlur={this.handleFormBlur}>
        {/* 応募者サークルID */}
        {
          <div>
            <h4 className="mt20">応募者サークル(※選択必須)</h4>
            <select
              className="form-control mb-3"
              id="circleId"
              onChange={this.onChangeField}
              value={this.state.circleId}
            >
              {this.props.myCircles}
            </select>
          </div>
        }
        {this.props.managerRecruitmentDetail.address_required_type == 0 ? (
          <div />
        ) : (
          <div>
            {/* お名前 */}
            {this.state.errors[FIELDS.userFamilyname] && (
              <p className="error">※お名前(姓)を入力してください。</p>
            )}
            {this.state.errors[FIELDS.userFirstname] && (
              <p className="error">※お名前(名)を入力してください。</p>
            )}
            <h4>お名前(※必須)</h4>
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text">姓</span>
              </div>
              <input
                className="form-control"
                placeholder="姓"
                type="text"
                onChange={this.onChangeField}
                id="userFamilyname"
                value={this.state.userFamilyname}
              />
            </div>
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <span className="input-group-text">名</span>
              </div>
              <input
                className="form-control"
                placeholder="名"
                type="text"
                onChange={this.onChangeField}
                id="userFirstname"
                value={this.state.userFirstname}
              />
            </div>
          </div>
        )}
        <div className="g-mt-30">
          {(this.state.errors[FIELDS.facebookUrl] ||
            this.state.errors[FIELDS.twitterUrl] ||
            this.state.errors[FIELDS.instagramUrl]) && (
            <p className="error">※SNSアカウントを一つ以上入力してください。</p>
          )}
          <h4>SNSアカウント (※任意)</h4>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fab fa-facebook" />
              </span>
            </div>
            <div className="input-group-prepend">
              <span className="input-group-text">
                https://www.facebook.com/
              </span>
            </div>
            <input
              className="form-control"
              placeholder="janedoe3"
              type="text"
              onChange={this.onChangeField}
              id="facebookUrl"
              value={this.state.facebookUrl}
            />
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fab fa-twitter" />
              </span>
            </div>
            <div className="input-group-prepend">
              <span className="input-group-text">https://twitter.com/</span>
            </div>
            <input
              className="form-control"
              placeholder="janedoe3"
              type="text"
              onChange={this.onChangeField}
              id="twitterUrl"
              value={this.state.twitterUrl}
            />
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="fab fa-instagram" />
              </span>
            </div>
            <div className="input-group-prepend">
              <span className="input-group-text">
                https://www.instagram.com/
              </span>
            </div>
            <input
              className="form-control"
              placeholder="janedoe3"
              type="text"
              onChange={this.onChangeField}
              id="instagramUrl"
              value={this.state.instagramUrl}
            />
          </div>
        </div>
        {/* PRコメント */}
        {this.state.errors[FIELDS.userComment] && (
          <p className="error">※PRコメントを入力してください。</p>
        )}
        <h4>PRコメント(※必須)</h4>
        <textarea
          className="form-control mb-3"
          placeholder="「こんなサークルにしたい」など"
          cols="65"
          rows="5"
          onChange={this.onChangeField}
          id="userComment"
          value={this.state.userComment}
        />

        <p>
          <small>※当募集には、スポンサー企業による選考があります。</small>
        </p>

        <div className="flex">
          {/* キャンセルボタン */}
          <button
            className="btn btn-lg btn-info mt20 mb20"
            style={{ width: '100%', margin: '10px' }}
            onClick={this.props.onClickCancelButton}
          >
            キャンセル
          </button>
          {/* 送信ボタン */}
          <button
            className="btn btn-lg btn-info mt20 mb20"
            style={{ width: '100%', margin: '10px' }}
            onClick={this.onSubmit}
            // disabled={this.state.circleType == '1' && this.state.circleId == ''}
            disabled={this.isDisabled()}
          >
            次へ
          </button>
        </div>

        {/* モーダル */}
        {/* 登録成功時 */}
        <ModalAlert
          ref={(c) => {
            this.modalAlertSuccess = c;
          }}
          id="modalAlertSuccess"
          title="アンバサダーへのお申込みが完了しました"
          content="企業からの連絡をお待ち下さい。"
          approveFunc={this.toNextPage}
        />
        {/* 登録失敗時 */}
        <ModalAlert
          ref={(c) => {
            this.modalAlertError = c;
          }}
          id="modalAlertError"
          title="登録失敗"
          content="登録に失敗しました。時間をおいてもう一度お試しください。"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  managerRecruitmentDetail: state.managerRecruitmentDetail,
  prefList: state.prefList,
  cityList: state.cityList,
  myCircleList: state.myCircleList,
  modalIsOpen: state.modalIsOpen,
  createStatus: state.createStatus,
  createdCircleId: state.createdCircleId,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getManagerRecruitmentDetail: (id) => {
      dispatch(
        actionCreators.communities.managerRecruitments.getManagerRecruitmentDetail(
          id
        )
      );
    },
    getPrefList: () => {
      dispatch(actionCreators.communities.managerRecruitments.getPrefList());
    },
    getCityList: (prefId) => {
      dispatch(
        actionCreators.communities.managerRecruitments.getCityList(prefId)
      );
    },
    getMyCircleList: () => {
      dispatch(
        actionCreators.communities.managerRecruitments.getMyCircleList()
      );
    },
    createManagerRecruitsUsers: (
      companiesCirclesManagerRecruitId,
      companyId,
      communityId,
      userId,
      circleId,
      userComment,
      userPrefId,
      userAddress,
      userPostal,
      userTel,
      userFamilyname,
      userFirstname,
      facebookUrl,
      twitterUrl,
      instagramUrl
    ) => {
      dispatch(
        actionCreators.communities.managerRecruitments.createManagerRecruitsUsers(
          companiesCirclesManagerRecruitId,
          companyId,
          communityId,
          userId,
          circleId,
          userComment,
          userPrefId,
          userAddress,
          userPostal,
          userTel,
          userFamilyname,
          userFirstname,
          facebookUrl,
          twitterUrl,
          instagramUrl
        )
      );
    },
  };
};

const Root = connect(mapStateToProps, mapDispatchToProps)(TmpRoot);
